// removed by extract-text-webpack-plugin
module.exports = {"list-no-results-wrapper":"list-no-results-wrapper","listNoResultsWrapper":"list-no-results-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/listWrapper/style.scss
// module id = 1381
// module chunks = 0